import { Slider } from "antd";
import styled from "styled-components";

export const StyledSlider = styled(Slider)`
  &.ant-slider {
    .ant-slider-rail {
      background: #292b2f;
      height: 8px;
      border-radius: 4px;
    }
    .ant-slider-track {
      background: linear-gradient(
        90.36deg,
        var(--main-color) 0.21%,
        #13c0cb 99.78%
      );
      height: 8px;
      border-radius: 4px;
    }
    .ant-slider-handle {
      border: none;
      width: 16px;
      height: 16px;
      &:after {
        width: 16px;
        height: 16px;
        box-shadow: 0px 2px 4px rgba(43, 45, 48, 0.67) !important;
      }
      &:hover {
        &:after {
          border: 2px solid #13c3b8 !important;
        }
      }
    }
    &:hover {
      .ant-slider-rail {
        background-color: #292b2f;
      }
    }
    &:hover {
      .ant-slider-track {
        background-color: #7e8486;
      }
    }
  }

  &.ant-slider-disabled {
    .ant-slider-rail {
      background: none;
      background-color: #292b2f !important;
    }
    .ant-slider-track {
      background: none;
      background-color: #7e8486 !important;
    }
  }
`;
